import React from "react";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import {useDispatch, useSelector} from "react-redux";
import {closeRightPanelDialogue} from "../../redux/actions";
import MultipleInputContent from "../../modal/MultipleInputContent";

export default function ({title, inputFields, onBack, onDone, onInputChange}) {
    let customer = useSelector(state => state.rootReducer.customer);
    const dispatch = useDispatch();

    if(customer !== false){
        setTimeout(() => {
            dispatch(closeRightPanelDialogue());
        }, 1)
        return null;
    }

    let backButton;
    if(onBack !== undefined){
        backButton = (
            <div onClick={onBack} style={{marginTop: '0.71rem', marginBottom: '0.71rem'}}>
                <Button type="button" className={"largeButton grayButton"} name={<Translate id="back"/>}
                    arrow="left" flencheClass={"flencheSmallLeftBottom grayFlenche"}/>
            </div>
        );
    }

    return (
        <div style={{
            padding: "0.71rem",
            paddingTop: "7.14rem",
            fontSize: "1.14rem",
            height: "100%"
        }}>
            <MultipleInputContent
                containerStyle={{
                    position: "auto",
                    height: "calc(100% - 7.14rem)"
                }}
                beforeInputFields={ <div className="fullWidth centerText" style={{marginBottom: "3.57rem"}}><span className="boldUppercaseText centerText">{ title }</span></div> }
                inputFields={ inputFields }
                onDone={onDone}
                onChange={onInputChange}
                afterInputFields={backButton}
                inputClassName={"fullWidth shadowBox"}
                inputStyle={{
                    boxSizing: "border-box"
                }}
            />
        </div>
    );
}
